import app from './src/app.vue'
import bugs from './src/bugs.vue'
import bulletins from './src/bulletins2.vue'
import categories from './src/categories.vue'
import checklist from './src/checklist.vue'
import contactlists from './src/contactlists.vue'
// import desktop from './src/desktop.vue'
import faq from './src/faq.vue'
import goal from './src/goal.vue'
import groups from './src/groups.vue'
import helps from './src/helps.vue'
import kpisetting from './src/kpisetting.vue'
import kpisnew from './src/kpisnew.vue'
// import login from './src/login.vue'
import login from './src/newLogin.vue'
import mobileLogin from './src/mobileLogin.vue'
import matchcandi from './src/matchcandi.vue'
import messages from './src/messages.vue'
import monitor from './src/monitor.vue'
import permissions from './src/permissions.vue'
import popover from './src/popover.vue'
import preview from './src/preview.vue'
import questions from './src/questions.vue'
import remind from './src/remind.vue'
import submitKpi from './src/submitKpi.vue'
import teammanage from './src/teammanage.vue'
import training from './src/training.vue'
import users from './src/users.vue'
import kpi from './src/kpi.vue'
import userBulletinPermissions from './src/user-bulletin-permissions.vue'
import tmpBulletins from './src/tmp-bulletins'
import trainingEdit from './src/training-edit.vue'
import projectReport from './src/project-report.vue'
import navigationBar from './src/navigation-bar.vue'
import templateUpload from './src/template-upload2.vue'
import formerYearsList from './src/formerYearsList.vue'
import CompanyReportDialog from './src/CompanyReportDialog.vue'
import NotifyList from './src/NotifyList.vue'
import waterMark from './src/waterMark.vue'
import peixun from './src/peixun/peixun.vue'
import PeixunDia from './src/peixun/PeixunDia.vue'

export {
  app,
  bugs,
  bulletins,
  categories,
  checklist,
  contactlists,
  // desktop,
  faq,
  goal,
  groups,
  helps,
  kpisetting,
  kpisnew,
  login,
  mobileLogin,
  matchcandi,
  messages,
  monitor,
  navigationBar,
  permissions,
  popover,
  preview,
  projectReport,
  questions,
  remind,
  submitKpi,
  teammanage,
  templateUpload,
  training,
  trainingEdit,
  // uploader: require('./src/uploader.vue'),
  users,
  kpi,
  userBulletinPermissions,
  tmpBulletins,
  formerYearsList,
  CompanyReportDialog,
  NotifyList,
  waterMark,
  peixun,
  PeixunDia,
}
